import React, { useState, useEffect } from 'react';
import ButtonBase from 'ui-coopeuch-button';
import { useDispatch } from 'react-redux';
import { timerActions } from '../../../../application/actions/timer';

import Mensaje from '../../atoms/CajaBloqueo';
import ClockHelper from '../Timer/ClockHelper';

import imagenPcPassCoopeuch from '../../../assets/img/pc-01.svg';
import imagenPassCoopeuch from '../../../assets/img/pass-01.svg';
import procesandoPassPc from '../../../assets/img/pc-02.svg';
import procesandoPassCel from '../../../assets/img/pass-02.svg';
import pcSuccess from '../../../assets/img/pc-success.svg';
import passSuccess from '../../../assets/img/pass-success.svg';
import cargandoExito from '../../../assets/img/cargando_passcoopeuch_exito.svg';
import reloj from '../../../assets/img/reloj-01.svg';
import validandoImg from '../../../assets/img/cargando_passcoopeuch.gif';
import errorImagen from '../../../assets/img/icon-error.svg';
import passBloqueado from '../../../assets/img/pass-bloqueo.svg';
import pcBloqueado from '../../../assets/img/pc-bloqueo.svg';

import PassCoopeuchContenedor from './styles';




const PassCoopeuch = ({ autorizationSubmit, reintentarSubmit,
  usuarioCancelo, appBloqueada, estadoInicioPass, casobordeLet, passcoopeuchCompletado, tercerFactorDisp
}) => {

  const dispatch = useDispatch();
  const [timerFlag, setTimerFlag]= useState(false)
  const [casoBorde, setCasoBorde] = useState({
    nombreBoton: 'Autorizar',
    colorBoton: 'complementary',
    casoBordeStatus: false,
    bloqueado: false
  });

  function reintentar(){
    reintentarSubmit();
    setTimerFlag(false);
    setCasoBorde({
      casoBordeStatus: false
    })
  }

  function onChangeIsTimeClear() {
    const interval = localStorage.getItem('setIntervalPassCoopeuch');
    clearInterval(interval);
    dispatch(timerActions.timerPassCoopeuch(true));
    setTimerFlag(true);
    setCasoBorde({
       nombreBoton: 'Reintentar',
      colorBoton: 'secondary',
      casoBordeStatus: true
    })
  }

  useEffect(() =>{
    if(usuarioCancelo){
      setCasoBorde({
        nombreBoton: 'Reintentar',
       colorBoton: 'secondary',
       casoBordeStatus: true
     })
    }
    if(appBloqueada){
      setCasoBorde({
        ...casoBorde,
        nombreBoton: 'Bloqueado',
        colorBoton: 'complementary',
        casoBordeStatus: true,
        bloqueado: true,
      });
    }
  },[usuarioCancelo,appBloqueada]);

  const { casoBordeStatus, nombreBoton, colorBoton, bloqueado } = casoBorde;
  const imgBloqueadasPC = bloqueado || casoBordeStatus? pcBloqueado : procesandoPassPc;
  const imgBloqueadasCel = bloqueado || casoBordeStatus ? passBloqueado : procesandoPassCel;

  if(passcoopeuchCompletado) {
    return (
      <PassCoopeuchContenedor>
        <div className="factor">
          <hgroup>
              <p>!PassCoopeuch validada exitosamente! {tercerFactorDisp ? 'Ahora te solicitaremos el tercer factor de seguridad.' : ''}</p>
          </hgroup>
          <div className="passCoopeuch-autorizar">
            <div className="box">
               <img src={pcSuccess} alt="passCoopeuch" />
            </div>
            <div className="box">
                <img src={cargandoExito} alt="Completado" />
            </div>
            <div className="box">
                <img src={passSuccess} alt="Pc completado" />
            </div>
          </div>
          <span>
            <p className="success-text mt-2">Tu PassCoopeuch ha sido ingresado correctamente</p>
          </span>
        </div>
      </PassCoopeuchContenedor>
    )
  }

  return (
    <PassCoopeuchContenedor>
      <div className="factor">
        <hgroup>
          {!bloqueado? (
            <>
              <p>{!estadoInicioPass || timerFlag ? ` Haz click en "${nombreBoton}" para enviar una ` : "Revisa la notificación que enviamos a tu teléfono y autoriza la operación."}</p>
              <p>{!estadoInicioPass || timerFlag ? 'notificación a tu teléfono.' : ''}</p>
          </>
          ):("")}
        </hgroup>
        <div className="passCoopeuch-autorizar">
          <div className="box">
             {!estadoInicioPass && !bloqueado && !casoBordeStatus? <img src={imagenPcPassCoopeuch} alt="passCoopeuch" /> : <img src={imgBloqueadasPC} alt="passCoopeuch" /> }
          </div>
          <div className="box btn-autorizar">
            {!estadoInicioPass || casoBordeStatus ? (
              <ButtonBase
                type={colorBoton}
                label={nombreBoton}
                onClick={(e) => casoBordeStatus? reintentar(e) : autorizationSubmit(e)}
                disabled={appBloqueada}
              />
            ) : (
              <img src={validandoImg} alt="validando" />
            )}
          </div>
          <div className="box">
          {!estadoInicioPass && !bloqueado && !casoBordeStatus?
             <img src={imagenPassCoopeuch} alt="e" />
             :
             <img src={imgBloqueadasCel} alt="e" />
            }
          </div>
        </div>
        <span className={casoBordeStatus ? "tiempo-pass-coopeuch error" : "tiempo-pass-coopeuch"} >
          {usuarioCancelo && (<p className="usuario_cancelo">Se ha rechazado esta operación.</p>)}
          {appBloqueada && (<Mensaje imagen={errorImagen} titulo={"Has excedido el límite de intentos."} parrafo={"Tu Passcoopeuch se encuentra bloqueada. Para desbloquearla, deberás registrarte nuevamente en la aplicación."} colorCaja={"#F9D4D5"} />)}

          {estadoInicioPass && !timerFlag ?(<ClockHelper
            mode="timer"
            initialTime={120}
            onChangeIsTimeUp={() => onChangeIsTimeClear()}
            complementaryText="para autorizar esta operación."
          />):("")}

            {!casoBordeStatus && !estadoInicioPass || timerFlag ?(
              <>
              <img src={reloj} alt="reloj" className="false-reloj" />
              <strong>{timerFlag ? "00:00 ": "02:00"}</strong> para autorizar esta operación.
              </>
            ):("")}

        </span>
      </div>
    </PassCoopeuchContenedor>
  )
};

export default PassCoopeuch;
